<template>
  <div>
    <div :style="{ background: '#fff', textAlign: 'center' }">
      <a-table
        :columns="columns"
        :row-key="(record) => record.id"
        :data-source="data"
        :pagination="pagination"
        :loading="loading"
        :customRow="selectHouse"
      >
        <template slot="name" slot-scope="text">
          <a-avatar :src="text.avatarURL" />
          {{ text.nickname }}
        </template>
        <template slot="plan" slot-scope="text">
          {{ text === undefined ? "-" : text.name }}
        </template>
        <template slot="planExpiredDate" slot-scope="text">
          {{
            text === undefined ? "-" : new Date(text).toISOString().slice(0, 10)
          }}
        </template>
      </a-table>
    </div>
  </div>
</template>


<script>
const AV = require("leancloud-storage");

const columns = [
  {
    title: "Name",
    dataIndex: "name",
    width: "20%",
  },
  {
    title: "Owner",
    dataIndex: "owner",
    width: "20%",
    scopedSlots: { customRender: "name" },
  },
  {
    title: "Plan",
    dataIndex: "plan",
    width: "20%",
    scopedSlots: { customRender: "plan" },
  },
  {
    title: "Expired Date",
    dataIndex: "planExpiredDate",
    width: "20%",
    scopedSlots: { customRender: "planExpiredDate" },
  },
];

export default {
  data() {
    return {
      data: [],
      pagination: {},
      loading: false,
      columns,
    };
  },
  mounted() {
    this.asyncData();
  },
  methods: {
    handleMenuClick(e) {
      console.log(e);
    },
    // handleChangePlanClick(e) {
    //   console.log(e);
    // },
    afterVisibleChange(val) {
      console.log("visible", val);
    },
    showDrawer() {
      this.visible = true;
    },
    onClose() {
      this.visible = false;
    },
    selectHouse(record, index) {
      return {
        on: {
          click: async () => {
            console.log(record, index);
            const result = await AV.Cloud.run("fetchAllHouse", {
              ownerId: record.id,
            });
            this.detail = {
              name: record.name,
              id: record.id,
              house: result[0],
            };
            this.showDrawer();
          },
          dblclick: () => {},
        },
      };
    },
    async asyncData() {
      // check token
      // jump sign in
      this.loading = true;
      const result = await AV.Cloud.run("fetchAllHouse");
      const houses = result;
      const pagination = { ...this.pagination };
      // Read total count from server
      pagination.total = houses.length;
      this.loading = false;
      this.data = houses;
      this.pagination = pagination;

      return { result };
    },
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;
      this.fetch({
        results: pagination.pageSize,
        page: pagination.current,
        sortField: sorter.field,
        sortOrder: sorter.order,
        ...filters,
      });
    },
  },
};
</script>

<style>
#components-layout-demo-fixed-sider .logo {
  height: 32px;
  background: rgba(255, 255, 255, 0.2);
  margin: 16px;
}
</style>
